import React from "react";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import { ActiveVkContainer } from "../../components/ActiveVkContainer/ActiveVkContainer";

export const ActiveVkScreen = () => {
  return <ScreenLayout>
    <ActiveVkContainer />
  {/* <ActiveAvitoContainer /> */}
</ScreenLayout>;
};
